import { NgOptimizedImage } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../model';
import { VeroeffentlichungsinformationenComponent } from './detail-inhalt/veroeffentlichungsinformationen/veroeffentlichungsinformationen.component';
import { DetailTabbarComponent, Tab } from './detail-tabbar/detail-tabbar.component';
import { TabAnbieterComponent } from './tab-anbieter/tab-anbieter.component';
import { TabDatenFaktenComponent } from './tab-daten-fakten/tab-daten-fakten.component';
import { TabInformationenComponent } from './tab-informationen/tab-informationen.component';

@Component({
  selector: 'now-wbsuche-lib-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    DetailTabbarComponent,
    TabInformationenComponent,
    TabDatenFaktenComponent,
    TabAnbieterComponent,
    VeroeffentlichungsinformationenComponent,
    NgOptimizedImage
  ]
})
export class DetailsComponent {
  @Input()
  public termin!: BildungsangebotTerminDetail;

  @Input()
  public currentTab!: Tab;

  mapPartnerIdZuName(id: string) {
    if (id === 'kursnet') {
      return 'KURSNET';
    }
    return id;
  }
}
